var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 78,
    viewBox: "0 0 92 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      color: "rgb(53, 86, 149)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1838 50.1579C78.4773 66.2477 63.6111 78.0001 46 78.0001C24.6063 78.0001 7.26318 60.657 7.26318 39.2632C7.26318 17.8694 24.6063 0.526367 46 0.526367C65.2948 0.526367 81.2947 14.6332 84.2486 33.0957L78.0789 24.7368L72.8401 31.8346C69.5896 20.0643 58.8042 11.4211 46 11.4211C30.6232 11.4211 18.1579 23.8864 18.1579 39.2632C18.1579 54.6399 30.6232 67.1053 46 67.1053C57.5105 67.1053 67.3896 60.1203 71.6298 50.1579H83.1838Z",
    fill: "#355695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.158 47.737L78.079 29.5791L92.0001 47.737H64.158Z",
    fill: "#355695"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.bfb03ac06444226b74dadfc9cdbc91fb.svg";
export { ForwardRef as ReactComponent };